import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { PMEVM } from 'src/app/api/module/portal/model/pme/pmeVM';
import { PMEService } from 'src/app/api/module/portal/services/pme/pme.service';
import { BlockTemplateComponent } from 'src/app/components/block-template/block-template/block-template.component';

@Component({
  selector: 'app-pme',
  templateUrl: './pme.component.html',
  styleUrls: ['./pme.component.scss']
})
export class PmeComponent implements OnInit {
  @BlockUI() public blockUI!: NgBlockUI;

  blockTemplate: BlockTemplateComponent | undefined;
  formGroupPME!: FormGroup
  listaCidades = new Array<any>();
  listaEstados = new Array<any>();
  enviarPME!: PMEVM
  isFormSubmited: boolean = false;
  formTouched: boolean = false;
  errorMessage: boolean = false;
  idEstado!:any
  idCidade!:any

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _pMEService: PMEService,

  ) { }

  ngOnInit(): void {
    this.criarFormulario();
    this.buscarListaEstados();
  }

  criarFormulario() {
    this.formGroupPME = this.formBuilder.group({
      Operadora: new FormControl('93FD2C0B-20CE-40F5-AB46-09570135F04C'),
      fonte: new FormControl(null),
      canal: new FormControl(null),
      campanha: new FormControl(null),
      descricaoProduto: new FormControl('PLENA SAÚDE PME'),
      nomeCompleto: new FormControl('', [Validators.maxLength(250)]),
      cnpj: new FormControl('', [Validators.required, Validators.maxLength(250)]),
      responsavelProposta: new FormControl('', [Validators.maxLength(250)]),
      contato: new FormControl(''),
      email: new FormControl('', [Validators.maxLength(250), Validators.email]),
      idEstado: new FormControl(null, [Validators.required]),
      idCidade: new FormControl(null, [Validators.required]),
      preferenciaContato: new FormControl(null),
      funcionarios00a18: new FormControl(null),
      funcionarios19a23: new FormControl(null),
      funcionarios24a28: new FormControl(null),
      funcionarios29a33: new FormControl(null),
      funcionarios34a38: new FormControl(null),
      funcionarios39a43: new FormControl(null),
      funcionarios44a48: new FormControl(null),
      funcionarios49a53: new FormControl(null),
      funcionarios54a58: new FormControl(null),
      funcionariosMais59: new FormControl(null),
      checkObrigatorio: new FormControl('on'),
    })
  }

  onFieldChange() {
    // Chamado sempre que um campo de entrada é alterado
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formGroupPME.valid;
  }

  buscarListaEstados() {
    this._pMEService.ListStates().subscribe((data: any) => {
      this.listaEstados = data && data;

      const indexOutro = this.listaEstados.findIndex((item: { name: string }) => item.name === "Outro");

      if (indexOutro > -1) {
        const outro = this.listaEstados.splice(indexOutro, 1)[0];
        this.listaEstados.push(outro)
      }
    })

  }

  changeEstado(estado: any) {
    this.ListCitiesByStates(estado.Id);
  }

  changeCidade(cidade: any) {
    this.idCidade = cidade.Id;
  }

  ListCitiesByStates(id: any[]) {
    if (id) {
      let state = [];
      state.push(id);
      this._pMEService.ListCitiesByStates(state).subscribe((data) => {
        this.listaCidades = data && data;
      });
    }
    this.idEstado = id
  }

  condionalDeObrigatoriedadeContatos(): boolean {
    let email = this.formGroupPME.controls['email'].value;
    let celular = this.formGroupPME.controls['contato'].value;
    if (!email && !celular) {
      return true
    }
    return false
  }

  validarCamposFuncionarios(min: number, max: number): boolean {

    const funcionarios00a18 = this.formGroupPME.get('funcionarios00a18')?.value || 0;
    const funcionarios19a23 = this.formGroupPME.get('funcionarios19a23')?.value || 0;
    const funcionarios24a28 = this.formGroupPME.get('funcionarios24a28')?.value || 0;
    const funcionarios29a33 = this.formGroupPME.get('funcionarios29a33')?.value || 0;
    const funcionarios34a38 = this.formGroupPME.get('funcionarios34a38')?.value || 0;
    const funcionarios39a43 = this.formGroupPME.get('funcionarios39a43')?.value || 0;
    const funcionarios44a48 = this.formGroupPME.get('funcionarios44a48')?.value || 0;
    const funcionarios49a53 = this.formGroupPME.get('funcionarios49a53')?.value || 0;
    const funcionarios54a58 = this.formGroupPME.get('funcionarios54a58')?.value || 0;
    const funcionariosMais59 = this.formGroupPME.get('funcionariosMais59')?.value || 0;

    const total = funcionarios00a18 + funcionarios19a23 + funcionarios24a28 +
      funcionarios29a33 + funcionarios34a38 + funcionarios39a43 +
      funcionarios44a48 + funcionarios49a53 + funcionarios54a58 +
      funcionariosMais59;

    if (total < min || total > max) {
      return true;
    }
    return false;
  }

  onReceberCotacao() {
    this.blockUI.start();
    this.formTouched = true;

    if (!this.isFormValid()) {
      this.blockUI.stop();
      this.errorMessage = true;
      this.isFormSubmited = true;
      this.toastr.warning("Verifique os campos obrigatórios.");
      return;
    }

    if (this.validarCamposFuncionarios(2, 29)) {
      this.toastr.warning("Necessário ter no minimo 2 vidas e no máximo 29 vidas.");
      this.blockUI.stop();
      return;
    }

    if (this.formGroupPME.valid) {
      this.enviarPME = Object.assign({}, this.enviarPME, this.formGroupPME.value);

      this.enviarPME.idEstado = this.idEstado;
      this.enviarPME.idCidade = this.idCidade;

      if (!this.enviarPME.pessoa) {
        this.enviarPME.pessoa = {
          dataNascimento: "01/01/2022",
          nomeCompleto: "Teste Empresa"
        };
      }
      
      this._pMEService.onReceberCotacao(this.enviarPME)
        .subscribe({
          next: (v: any) => {
            this.toastr.success("Enviado com sucesso!");
            this.formGroupPME.reset();
            this.formTouched = false;
            this.errorMessage = false;
            this.isFormSubmited = false;      
            this.blockUI.stop();
          },
          error: (e: any) => {
            this.toastr.toastrConfig.preventDuplicates = true;
            var mensagemTratada = e.message.replace("Error:", "");
            if (mensagemTratada.includes("Erro ao enviar Cotação")) {
              this.toastr.error(mensagemTratada);
              this.blockUI.stop();
              return;
            } else {
              this.toastr.error("Erro ao receber Cotação");
              this.blockUI.stop();
            }
          },
        });
    }
  }
}
